var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25894 14.1531V9.80528H9.73716V14.1531C9.73716 14.6313 10.1285 15.0226 10.6067 15.0226H13.2154C13.6936 15.0226 14.0849 14.6313 14.0849 14.1531V8.06617H15.5632C15.9632 8.06617 16.1545 7.57052 15.8501 7.30966L8.58065 0.761898C8.25022 0.466249 7.74588 0.466249 7.41545 0.761898L0.145957 7.30966C-0.149692 7.57052 0.0329144 8.06617 0.43291 8.06617H1.91116V14.1531C1.91116 14.6313 2.30246 15.0226 2.78071 15.0226H5.38938C5.86764 15.0226 6.25894 14.6313 6.25894 14.1531Z",
    fill: "#DFDEFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25289_16119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6c52132a.svg";
export { ForwardRef as ReactComponent };